import { render, staticRenderFns } from "./ParamDocumentation.vue?vue&type=template&id=36b8643f&scoped=true&"
import script from "./ParamDocumentation.js?vue&type=script&lang=js&"
export * from "./ParamDocumentation.js?vue&type=script&lang=js&"
import style0 from "./ParamDocumentation.vue?vue&type=style&index=0&id=36b8643f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b8643f",
  null
  
)

export default component.exports